// extracted by mini-css-extract-plugin
module.exports = {"Square":"Square_Square__1MR6i","appear":"Square_appear__2Q2dq","Promo":"Square_Promo__2Qq_x"};